import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
  state: {
    userList: [],
  },
  mutations: {},
  actions: {
    async getTopBannerList(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getTopBannerList`, data)

          if (!result.data.errorCode || result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async getTopBannerDetail(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getTopBannerDetail`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async createTopBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/createTopBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async updateTopBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/updateTopBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
    async deleteTopBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/deleteTopBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
  },
  getters: {}
}

export default moduleStore;